
import React from 'react';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { CalendarDays } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';

interface DateDisplayProps {
  currentTime: Date;
}

const DateDisplay: React.FC<DateDisplayProps> = ({ currentTime }) => {
  const isMobile = useIsMobile();
  
  // Formatea la fecha para mostrar "9 abril" en lugar del día del año
  const formattedDate = format(currentTime, "d 'de' MMMM", { locale: es });
  const dayOfWeek = format(currentTime, "EEEE", { locale: es });
  const formattedTime = format(currentTime, "HH:mm");
  
  return (
    <div className={`flex items-center bg-white/60 backdrop-blur-sm p-2 rounded-lg shadow-sm border border-gray-100 ${isMobile ? 'mx-auto w-full max-w-xs justify-center' : ''}`}>
      <CalendarDays className="h-5 w-5 text-vegana-primary mr-2" />
      <div>
        <div className="flex items-center">
          <span className="font-medium capitalize">{dayOfWeek}</span>
          <span className="mx-1 text-gray-400">•</span>
          <span>{formattedDate}</span>
        </div>
        <div className="text-sm text-gray-600">{formattedTime}</div>
      </div>
    </div>
  );
};

export default DateDisplay;
